<app-load-general [load]="isLoading"></app-load-general>
<div class="h-vh w-vw flex flex-col justify-start items-center">
  <div
    class="w-full flex justify-center items-center bg-[url('assets/img/fondo.jpg')] h-20 sm:h-60 xl:h-100 bg-cover"
  >
    <img
      [attr.alt]="'login.logoAlt' | translate"
      class="w-50 sm:w-120 xl:w-200 py-4"
      src="assets/icons/logo-general-blanco.svg"
    />
  </div>

  <div class="h-full justify-around place-items-baseline flex-col flex">
    <div class="box-home max-w-190 w-auto m-4">
      <form
        [formGroup]="loginForm"
        (ngSubmit)="login()"
        class="flex flex-col justify-between gap-7 p-6 aa-input-general"
      >
        <div
          class="text-2xl font-light w-auto sm:w-[80%] text-center m-auto text-(--color-text-primary)!"
        >
          {{ 'login.instruction' | translate }}
        </div>

        <div class="w-full m-auto">
          <app-input-general
            [label]="'login.username'"
            [placeholder]="'login.username'"
            [type]="'text'"
            [formControlGeneral]="getControl(loginForm, 'username')"
          ></app-input-general>
        </div>
        <div class="w-full m-auto">
          <app-input-general
            [label]="'login.password'"
            [placeholder]="'login.password'"
            [type]="'password'"
            [formControlGeneral]="getControl(loginForm, 'password')"
          ></app-input-general>
        </div>
        <div class="w-66.25 m-auto justify-center flex">
          <button
            class="button-general-border w-full"
            matButton
            type="submit"
            [disabled]="isLoading || loginForm.invalid"
          >
            <div class="flex justify-center items-center gap-4">
              <div>{{ 'common.actions.enter' | translate }}</div>
            </div>
          </button>
        </div>
      </form>
      <div class="w-full text-end">v.B1.1.1</div>
    </div>
  </div>
</div>
